import React, { useContext } from 'react';
import { IRestaurantsContext, RestaurantsContext } from '../../../../restaurantsState/restaurantsContext';
import Text from 'components/Text/Text';
import { Item } from './components/Item';
import classNames from 'classnames';
import style from './ArchivedRestaurantsList.module.scss';

export const ArchivedRestaurantsList: React.FC = () => {
	const { restaurants } = useContext<IRestaurantsContext>(RestaurantsContext);

	const nameHeadingClasses = classNames(style.name, style.heading);
	const customerHeadingClasses = classNames(style.customer, style.heading);
	const cityHeadingClasses = classNames(style.city, style.heading);
	const countryHeadingClasses = classNames(style.country, style.heading);
	const archivingDateHeadingClasses = classNames(style.archivingDate, style.heading);
	const userHeadingClasses = classNames(style.user, style.heading);
	const actionHeadingClasses = classNames(style.action, style.heading);

	return (
		<div className={style.container} data-test="ArchivedRestaurantsList">
			<div className={style.tableHeaders}>
				<div className={nameHeadingClasses}>
					<Text
						translationNameSpace="listing"
						translationKey="nameLabel"
						theme="neutralLight"
						withTooltip={true}
					/>
				</div>
				<div className={customerHeadingClasses}>
					<Text
						translationNameSpace="listing"
						translationKey="customerLabel"
						theme="neutralLight"
						withTooltip={true}
					/>
				</div>
				<div className={cityHeadingClasses}>
					<Text
						translationNameSpace="listing"
						translationKey="cityLabel"
						theme="neutralLight"
						withTooltip={true}
					/>
				</div>
				<div className={countryHeadingClasses}>
					<Text
						translationNameSpace="listing"
						translationKey="countryLabel"
						theme="neutralLight"
						withTooltip={true}
					/>
				</div>
				<div className={archivingDateHeadingClasses}>
					<Text
						translationNameSpace="listing"
						translationKey="archivingDateLabel"
						theme="neutralLight"
						withTooltip={true}
					/>
				</div>
				<div className={userHeadingClasses}>
					<Text
						translationNameSpace="listing"
						translationKey="userLabel"
						theme="neutralLight"
						withTooltip={true}
					/>
				</div>
				<div className={actionHeadingClasses}>
					<Text
						translationNameSpace="listing"
						translationKey="actionLabel"
						theme="neutralLight"
						withTooltip={true}
					/>
				</div>
			</div>
			{restaurants.restaurants.map((item, index) => (
				<Item data={item} key={item.id} index={index} />
			))}
		</div>
	);
};
